import {observer} from 'mobx-react-lite'
import React from 'react'
import {DataObjectId} from 'yougile-model'
import {boardSettingsState} from '@components/board/board-settings/board-settings-store'
import {RemoveStickerPopup} from '@components/sticker/my-stickers/board-stickers/remove-sticker-popup'
import {CreatingSticker} from '@components/sticker/my-stickers/creating-sticker'
import {EditingSticker} from '@components/sticker/my-stickers/editing-sticker'
import {NewSticker} from '@components/sticker/my-stickers/new-sticker'
import {useBoard, useMemoOne, useSyncEvent} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {Project} from '@extensions/project'
import {BoardStickers} from './board-stickers/board-stickers'
import {
  MyStickersContext,
  MyStickersStore,
  Tab,
  useMyStickersStore
} from './my-stickers-store'
import {StickerLibrary} from './sticker-library/sticker-library'

interface MyStickersProps {
  currentTab?: Tab
}

export interface MyStickersBoardSettingsTabInfo {
  stickerIdToEdit?: DataObjectId | undefined
}

// todo: here
// TODO! Rename the folder in - stickers settings!
export const MyStickers = ({currentTab}: MyStickersProps) => {
  const board = useBoard()
  const store = useMemoOne(() => {
    const store = new MyStickersStore(currentTab)
    const stickerIdToEdit =
      boardSettingsState.additionalTabInfo?.stickerIdToEdit
    if (stickerIdToEdit) {
      store.editSticker(stickerIdToEdit)
    }
    store.sync(board)
    return store
  }, [currentTab, board])

  useSyncEvent(
    'current',
    {debounceTime: 500, filter: board.id},
    () => store.sync(board),
    [board]
  )

  // library depends on all other board stickers; when other boards are updated,
  // their projects are updated too
  const projects = Project.listProjects(globals.getCompanyId(), 'not-archive')
  useSyncEvent(
    'current',
    {debounceTime: 500, filter: projects.map(x => x.id)},
    () => store.syncLibrary(board),
    [board]
  )

  return (
    <MyStickersContext.Provider value={store}>
      <MyStickersBase />
      <RemoveSticker />
    </MyStickersContext.Provider>
  )
}

const MyStickersBase = observer(() => {
  const [state] = useMyStickersStore()

  switch (state.currentTab) {
    case 'board':
      return <BoardStickers />
    case 'library':
      return <StickerLibrary />
    case 'new':
      return <NewSticker />
    case 'creating':
      return <CreatingSticker />
    case 'editing':
      return <EditingSticker />
  }
})

const RemoveSticker = observer(() => {
  const [state, store] = useMyStickersStore()

  return state.stickerToRemove ? (
    <RemoveStickerPopup
      sticker={state.stickerToRemove}
      close={store.closeRemoveStickerPopup}
    />
  ) : null
})
